import { render, staticRenderFns } from "./departments-table.vue?vue&type=template&id=f2710f40&"
import script from "./departments-table.vue?vue&type=script&lang=js&"
export * from "./departments-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports